import {
  Card,
  Checkbox,
  useGlobalNavigationHotkeys,
} from "@permutation-city/ui";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { UserBalance } from "../components/UserBalance";
import { useDustClient } from "../hooks/useDustClient";
import { useAppStore } from "../store/appStore";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: () => {
    return (
      <p className="text-2xl font-bold text-center mt-24">404 NOT FOUND</p>
    );
  },
});

function Root() {
  const { data: dustClient } = useDustClient();
  const { autoSwitch, setAutoSwitch } = useAppStore();
  useGlobalNavigationHotkeys();

  return (
    <div className="grid grid-rows-[40px_auto] h-full min-w-0 min-h-0">
      <div className="flex items-center justify-between px-4">
        <div className="">
          <Checkbox
            name="switch"
            checked={autoSwitch}
            defaultChecked={autoSwitch}
            onChange={() => setAutoSwitch(!autoSwitch)}
          >
            AUTO-SWITCH
          </Checkbox>
        </div>

        <UserBalance address={dustClient?.appContext.userAddress} />
      </div>

      <div className="h-full px-4 pb-4">
        <Card>
          <Outlet />
        </Card>
      </div>
    </div>
  );
}
